// Report this page's uncaught errors to the server's error digest (src/worker/errorLog.ts), a few per page
// load at most. The server scrubs and groups them; the route is sent without its query string.
const MAX_REPORTS = 5;
let sent = 0;

export function reportClientError(message: string): void {
  if (sent >= MAX_REPORTS || !message) return;
  sent++;
  const body = JSON.stringify({ message: message.slice(0, 500), route: location.pathname });
  try {
    if (!navigator.sendBeacon?.("/api/client-error", new Blob([body], { type: "application/json" }))) {
      void fetch("/api/client-error", { method: "POST", headers: { "content-type": "application/json" }, body, keepalive: true }).catch(() => {});
    }
  } catch { /* reporting must never break the page */ }
}

export function installErrorReporter(): void {
  window.addEventListener("error", (event) => reportClientError(event.error instanceof Error ? `${event.error.name}: ${event.error.message}` : String(event.message ?? "")));
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    reportClientError(reason instanceof Error ? `Unhandled rejection: ${reason.name}: ${reason.message}` : `Unhandled rejection: ${String(reason).slice(0, 200)}`);
  });
}
